import css from './spacer.less'

// https://www.joshwcomeau.com/react/modern-spacer-gif/

export interface SpacerProps {
    width?: number|string
    height?: number|string
}

export function BlockSpacer({width,height}: SpacerProps) {
    return <span className={css.blockSpacer} style={{width,minWidth:width,height,minHeight:height}}/>
}

export function InlineSpacer({width,height}: SpacerProps) {
    return <span className={css.inlineSpacer} style={{width,minWidth:width,height,minHeight:height}}/>
}
